module.exports = __webpack_public_path__ + "img/big.88b89098.jpg";